import React, { useEffect, useState } from "react";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import defaultimg from "../../assets/images/default-img.png";
const ThumbSlider = ({ singleProductData, discount_percentage }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [key, setKey] = useState(0);
  useEffect(() => {
    if (singleProductData) {
      setActiveIndex(0);
      setKey((prevKey) => prevKey + 1);
    }
  }, [singleProductData?._id]);
  if (!singleProductData) {
    return null;
  }
  const mainOptions = {
    items: 1,
    nav: false,
    dots: false,
    margin: 0,
    loop: true,
    autoplayHoverPause: true,
    onChange: (event) => {
      setActiveIndex(event.item.index);
    },
  };

  const thumbOptions = {
    items: 4,
    nav: false,
    dots: false,
    margin: 10,
    responsive: {
      0: {
        items: 3,
      },
      768: {
        items: 4,
      },
    },
  };

  const handleThumbClick = (index) => {
    setActiveIndex(index);
    // console.log(index)
  };

  return (
    <div className="col-lg-5">
      <div className="product-details-lft">
        <div className="">
          <OwlCarousel
            className="owl-theme"
            id="product-main-slide"
            {...mainOptions}
            startPosition={activeIndex}
          >
            {singleProductData.map((image, index) => (
              <div 
                className="product-main position-relative" 
                key={index}
                style={{
                  aspectRatio: '1080/720',
                  width: '100%',
                  overflow: 'hidden'
                }}
              >
                {discount_percentage > 0 && (
                  <div 
                    style={{
                      position: 'absolute',
                      top: '10px',
                      left: '10px',
                      backgroundColor: '#4CAF50',
                      color: 'white',
                      padding: '6px 14px',
                      borderRadius: '20px',
                      fontSize: '18px',
                      fontWeight: '500',
                      zIndex: 1,
                      boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                    }}
                  >
                    {discount_percentage}% OFF
                  </div>
                )}
                <img
                  src={image || defaultimg}
                  alt={`Product ${index + 1}`}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain',
                    objectPosition: 'center'
                  }}
                />
              </div>
            ))}
          </OwlCarousel>

          <OwlCarousel
            className="owl-theme"
            id="thumbs-slide"
            {...thumbOptions}
            startPosition={activeIndex}
          >
            {singleProductData.map((image, index) => (
              <div
                className={`product-thumb ${activeIndex === index ? "active" : ""}`}
                key={index}
                onClick={() => handleThumbClick(index)}
                style={{
                  aspectRatio: '1080/720',
                  overflow: 'hidden'
                }}
              >
                <img
                  src={image || defaultimg}
                  alt={`Thumbnail ${index + 1}`}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain',
                    objectPosition: 'center'
                  }}
                />
              </div>
            ))}
          </OwlCarousel>
        </div>
      </div>
    </div>
  );
};

export default ThumbSlider;
